import {
	QueryParamConfig,
	UrlUpdateType,
	decodeDelimitedArray,
	encodeDelimitedArray,
	useQueryParam
} from 'use-query-params';
import { CheckboxItem } from 'components/core/checkbox-group';
import { useAppSelector } from 'redux/store';
import { RadioButtonItem } from 'components/core/radio-button-group';

export const GROUP_QUERY_KEY = 'doelgroep';

type NewValueType<D> = D | ((latestValue: D) => D);

export type UseGroupReturn = {
	selectedGroups: CheckboxItem[];
	selectedGroupsParam: string | (string | null)[] | null | undefined;
	setSelectedGroupsParam: (
		newValue: NewValueType<RadioButtonItem | null | undefined>,
		updateType?: UrlUpdateType | undefined
	) => void;
};

export const useGroup = (): UseGroupReturn => {
	const { groups } = useAppSelector((state) => state.groups);

	const [selectedGroupsParam, setSelectedGroupsParam] = useQueryParam(GROUP_QUERY_KEY, GroupArrayParam);
	const selectedGroups = groups.filter((group) => selectedGroupsParam?.includes(String(group.id)));

	return {
		selectedGroups: selectedGroups.map((group) => ({
			id: group.id,
			label: group.name
		})),
		selectedGroupsParam,
		setSelectedGroupsParam
	};
};

export const GroupArrayParam: QueryParamConfig<
	RadioButtonItem | null | undefined,
	string | (string | null)[] | null | undefined
> = {
	encode: (item) => {
		if (!item?.id) {
			return null;
		}

		return encodeDelimitedArray([item.id.split('-')[1]]);
	},
	decode: (param) => {
		return decodeDelimitedArray(param);
	}
};
